module.exports = __webpack_public_path__ + "img/AmountPayable.e767f73f.svg";